export default "__VITE_ASSET__DmNoK51L__"